import { DatePicker, DatePickerProps } from '@material-ui/pickers';
import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import DatePickerToolbar from './DatePickerToolbar';

export type SGSDatePickerProps = DatePickerProps & {
    name: string;
};

const SGSDatePicker: React.FC<SGSDatePickerProps> = ({ name, views, ...props }) => {
    const { t } = useTranslation();
    const { control, formState } = useFormContext();
    const { errors } = formState;

    return (
        <>
            <Controller
                control={control}
                name={name}
                render={({ field }) => (
                    <DatePicker
                        {...field}
                        {...props}
                        ToolbarComponent={DatePickerToolbar}
                        views={views || ['year', 'month', 'date']}
                        autoOk={true}
                        cancelLabel={t('global.cancel')}
                        clearLabel={t('global.clear')}
                        okLabel={t('global.ok')}
                        todayLabel={t('global.today')}
                        error={Boolean(errors[name])}
                        helperText={errors[name]?.message}
                    />
                )}
            />
        </>
    );
};

export default SGSDatePicker;
